import MenuLink from "./MenuLink";
import Loader from "../../components/Loader";
import { P2 } from "../../components/Paragraph";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useTasksLink from "./hooks/useTasksLink";

const TasksLink = () => {
  const { t } = useTranslation();
  const {
    isOpen,
    handleDropdownClick,
    assignments,
    assignmentsLoading,
    counter,
  } = useTasksLink();

  return (
    <MenuLink
      caption={t("nav.tasks")}
      to="/tasks"
      onDropdownClick={handleDropdownClick}
      isOpen={isOpen}
      counter={counter}
    >
      {assignments ? (
        <>
          {assignments?.map((assignment) => (
            <Link
              key={assignment?.id}
              style={{ textDecoration: "none" }}
              to={`/tasks/${assignment?.id}`}
            >
              <P2 key={assignment?.id}>{assignment?.topic}</P2>
            </Link>
          ))}
        </>
      ) : assignmentsLoading ? (
        <Loader xs />
      ) : null}
    </MenuLink>
  );
};

export default TasksLink;
